export enum ActiveStatus {
  ACTIVE = 'active',
  IN_ACTIVE = 'inactive',
  ALL = 'all',
  PENDING_APPROVALS = 'pendingApprovals'
}
